import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
  container: {
    textAlign: 'center',
  },
});

export default withStyles(styles)(props => {
  const { classes } = props;
  return (
    <div className={classes.container}>
      <CircularProgress className={classes.progress} size={50} style={{ color: '#0098DA' }} />
    </div>
  );
});
